import { ConditionalRule, ConditionalRuleKind } from './types';
import getConditionalRules from './getConditionalRules';

export default (): ConditionalRule => {
  return getConditionalRules().find(
    (r) => r.value === ConditionalRuleKind.EQUALS
  ) as ConditionalRule;
};
